import { shallowRef } from 'vue'
import { DEFAUT_STYLE_ENTETE, type StyleEntete } from './entete'

/**
 * Disposition APPLIQUÉE au document, en état réactif : la seule partie du
 * réglage `header` que le CSS ne peut pas porter. Sans barre du haut, la marque
 * et les commandes du compte doivent être RENDUES dans la barre latérale — le
 * CSS seul peut masquer la barre, pas déplacer ses contrôles.
 *
 * Écrite par `appliquer.ts` — et par lui seul — à chaque application de
 * l'apparence (cache, serveur, autre onglet, enregistrement). Lue par
 * `layouts/AppLayout.vue`, qui restructure la coquille quand elle change.
 */
export const enteteAppliquee = shallowRef<StyleEntete>(DEFAUT_STYLE_ENTETE)
